import { render, staticRenderFns } from "./InternalMoving.vue?vue&type=template&id=c56f39e2&scoped=true"
import script from "./InternalMoving.vue?vue&type=script&lang=js"
export * from "./InternalMoving.vue?vue&type=script&lang=js"
import style0 from "./InternalMoving.vue?vue&type=style&index=0&id=c56f39e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f39e2",
  null
  
)

export default component.exports